import Modal from '../modal/modal';

const DOWNLOAD_SELECTOR = ['a[href^="/dl/"]', 'a[href^="https://graphisoft.com/dl/"]'];
const MARKETO_FORM_ID = 2032;
const MARKETO_MUNCHKIN_ID = '723-WOG-471';

let modal = new Modal();
const DEBOUNCE_DELAY = 500;
const COOLDOWN_PERIOD = 1 * (60 * 1000);
const submittedLinks = new Map();
let lastClickTime = 0;

/**
 * Downloads
 */
!function(selector){
    const tokenMeta = document.querySelector('meta[name="csrf-token"]');
    const siteMeta = [...document.querySelectorAll('meta[name="site"]')].pop();
    const gsidEmailElement = document.querySelector('[data-user-email]');
    const gsidEmail = gsidEmailElement ? gsidEmailElement.dataset.userEmail : null;

    document.addEventListener('click', function (event) {
        let downloadLink;

        for (let i = 0; i < DOWNLOAD_SELECTOR.length; i++) {
            if (event.target.matches(DOWNLOAD_SELECTOR[i])) {
                downloadLink = event.target;
                break;
            }

            if (!downloadLink && event.target.closest(DOWNLOAD_SELECTOR[i])) {
                downloadLink = event.target.closest(DOWNLOAD_SELECTOR[i]);
                break;
            }
        }

        if (!downloadLink) return; // Not a download link

        const now = Date.now();

        event.preventDefault();

        // ha az adott linkre már volt beküldés az elmúlt 2 percben, ne engedjük újra
        const lastSubmitted = submittedLinks.get(downloadLink.href);
        if (lastSubmitted && (now - lastSubmitted) < COOLDOWN_PERIOD) {
            console.log('DOWNLOAD cooldown active for', downloadLink.href);
            return;
        }

        // Initiate Download Request
        const xhr = new XMLHttpRequest();
        xhr.open('POST', downloadLink.href);
        xhr.setRequestHeader('X-CSRF-TOKEN', tokenMeta && tokenMeta.content);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('x-site', siteMeta && siteMeta.content);

        xhr.onload = function() {
            if (xhr.status === 200) {
                let data = JSON.parse(xhr.responseText);

                if (data.action && data.action === 'OK') {
                    submittedLinks.set(downloadLink.href, Date.now());
                    const downloadUrl = data.message;


                    if (now - lastClickTime < DEBOUNCE_DELAY) {
                      window.location.href = downloadUrl;
                      return;
                    } else {
                      if (gsidEmail) {
                        MktoForms2.loadForm('//web.graphisoft.com', MARKETO_MUNCHKIN_ID, MARKETO_FORM_ID, function(form) {
                          form.addHiddenFields({
                            "Email": gsidEmail,
                            "temporaryInfoString2": downloadUrl,
                          });
  
                          // Add UTM parameters
                          if (typeof GS.UTM !== 'undefined') {
                            const fields = {};
                            const parameters = GS.UTM.get();
                            for (const key in parameters) {
                              if (parameters.hasOwnProperty(key) && parameters[key] !== undefined) {
                                fields[key] = parameters[key];
                              }
                            }
                            form.addHiddenFields(fields);
                              form.onSuccess(function(values, followUpUrl) {
                                  GS.UTM.reset();
                              });
                          }
  
                          form.onSuccess(function(values, followUpUrl) {
                            window.location.href = downloadUrl;
                            return false;
                          });
  
                          form.submit();
                        });
                      }
                    }
                    lastClickTime = now;

                } else {
                    const content = data.message;
                    modal.show(content.title, content.body, content.footer);
                }
            } else {
                console.error('DOWNLOAD request failed!', xhr.status, xhr.responseText);
            }
        };
        xhr.onerror = function() {
            console.error('DOWNLOAD request failed due to network error!');
        };
        xhr.send();


    }, true);
}(DOWNLOAD_SELECTOR);